import React, { useState } from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap'
import { courseDetails, displayFile, studentDetails, transferDetail, transferInDetail } from './constant'
import { ReactComponent as DownArrow } from "assets/img/svg/downarrow.svg"
import { ReactComponent as Uparrow } from "assets/img/svg/upwardArrow.svg";

const StudentDetail = ({
    details
}) => {
    const [open, setOpen] = useState({student:true,transfer:true})
    const getFormatCol = (label = '', value = '',item, flag = false, index) => {
        return <>
            <Col md={4} className='mt-24'>
                <div>
                    <div className="large-semi-bold label-color break-words whitespace-normal">
  {(value && value !== " ") 
    ? Array.isArray(value) 
      ? label == 'Request form' 
        ? displayFile(value) 
        : value.join(', ') 
      : item?.renderData?.(value )
    : label == 'PSERP ID' 
      ? <span style={{ color: '#D29822' }}>In progress</span> 
      : '-'}
</div>

                    <div className='regular-small'>
                        {label}
                    </div>
                </div>
            </Col>
            {flag && index == 4 ? <Col md={4} className='mt-24'></Col> : ''}

        </>
    }

    return (
        <>
            <Card >
                <CardBody>

                    <div className='d-flex justify-content-between align-items-center'>
                        <div className='dark-text label-color'>Student Details</div>
                        <div className="cursor" onClick={() => { setOpen((prev) => ({...prev,student:!prev?.student})) }}>{open?.student ? <Uparrow /> : <DownArrow />}</div>
                    </div>
                    {open?.student && <>
                        <div className='mt-24' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
                        <div className='tiny-semi-bold mt-24' >
                        </div>
                        <Row>
                            {studentDetails.map((item) => {
                                return getFormatCol(item?.label, details?.[item?.key],item)

                            })}
                            {console.log(details, 'studentDetails')}
                        </Row >
                        <div className='mt-24' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
                        <div className='tiny-semi-bold mt-24'>
                            COURSE DETAILS
                        </div>
                        <Row>
                            {courseDetails.map((item) => {
                                return getFormatCol(item?.label, details?.[item?.key], item)

                            })}
                        </Row ></>}
                </CardBody>
            </Card>
            <Card >
                <CardBody>
                    <div className='d-flex justify-content-between align-items-center'>
                        <div className='dark-text label-color'>Transfer IN details</div>
                        <div className="cursor" onClick={() => { setOpen((prev) => ({...prev,transfer:!prev?.transfer})) }}>{open?.transfer ? <Uparrow /> : <DownArrow />}</div>
                    </div>
                    {open?.transfer && <>
                        <div className='mt-24' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
                        <Row>
                            {transferInDetail.map((item) => {
                                return getFormatCol(item?.label, details?.[item?.key], item)

                            })}
                        </Row></>}
                </CardBody>
            </Card>

        </>

    )
}
export default StudentDetail